import React, { useState } from 'react';
import { useAuth } from '../App';

export default function LoginPage() {
  const { login } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [otp, setOtp] = useState('');
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await fetch('/api/login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      if (data.need_otp) { setUserId(data.user_id); }
      else { login(data.token, data.user); }
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await fetch('/api/verify-otp', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ user_id: userId, code: otp }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      login(data.token, data.user);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">
          <span className="login-logo-icon">🏢</span>
          <h1>РентМенеджер</h1>
          <p>Управленческий учёт аренды студий</p>
        </div>

        {error && <div className="error-msg" style={{ marginBottom: 16 }}>{error}</div>}

        {!userId ? (
          <form className="login-form" onSubmit={submit}>
            <div className="form-group">
              <label>Логин</label>
              <input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} placeholder="admin" autoFocus />
            </div>
            <div className="form-group">
              <label>Пароль</label>
              <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="••••••••" />
            </div>
            <button className="btn btn-primary" style={{ marginTop: 8, justifyContent: 'center' }} disabled={loading}>
              {loading ? 'Вход...' : 'Войти →'}
            </button>
          </form>
        ) : (
          <form className="login-form" onSubmit={verifyOtp}>
            <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16, textAlign: 'center' }}>
              Код подтверждения отправлен на ваш email
            </p>
            <div className="form-group">
              <label>Код из письма</label>
              <input value={otp} onChange={e => setOtp(e.target.value)} placeholder="123456" autoFocus maxLength={6} style={{ fontSize: 24, textAlign: 'center', letterSpacing: 8 }} />
            </div>
            <button className="btn btn-primary" style={{ marginTop: 8, justifyContent: 'center' }} disabled={loading}>
              {loading ? 'Проверка...' : 'Подтвердить →'}
            </button>
            <button type="button" className="btn btn-ghost" style={{ justifyContent: 'center' }} onClick={() => setUserId(null)}>
              ← Назад
            </button>
          </form>
        )}

        <p style={{ fontSize: 12, color: 'var(--text3)', textAlign: 'center', marginTop: 20 }}>
          По умолчанию: admin / admin123
        </p>
      </div>
    </div>
  );
}
